module.exports = __webpack_public_path__ + "img/round-right-arrow-icon.svg";